import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Lottie from 'react-lottie';
import * as animationData from '../../../img/lottie/240187_ARG_Website_Arrow.json'

// @ts-ignore
import {ReactComponent as Arrow} from "../../../img/Argenco_pijl_eco_rgb.svg";
// @ts-ignore
import {ReactComponent as ArrowDark} from "../../../img/Argenco_pijl_green_rgb.svg";
// @ts-ignore
import ImgLevi from "../../../img/cut/ArgenCo_Levi_CEO.jpg";
// @ts-ignore
import {ReactComponent as Plus} from "../../../img/ArgenCo_icon_plus_rgb.svg";
// @ts-ignore
import {ReactComponent as Graph} from "../../../img/ArgenCo_icon_graph_rgb.svg";
// @ts-ignore
import {ReactComponent as House} from "../../../img/ArgenCo_icon_house_rgb.svg";
// @ts-ignore
import {ReactComponent as Clover} from "../../../img/ArgenCo_icon_clover_rgb.svg";

import {
  Box
} from '@mui/material';

// import {
//   Cta,
//   Footer,
//   Section
// } from '../custom';
import {
  MutedGreenButton,
  ShareShower,
  Typography
} from '../styled';

import { EmissionKey as EK } from '../../../models/EmissionKey';


type Props = {
  emissionKey?: EK;
  isNew?: boolean;
  isApproved?: boolean;
  gift?: boolean;
  onClick: () => void;
  shareTypeTag: 'A' | 'B';
  sx?: any;
};

export const EmissionKeyAlt1: FunctionComponent<Props> = ({emissionKey, isNew, isApproved, gift, sx, onClick, shareTypeTag}) => {
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);
  const navigate = useNavigate();

  const [stopped, setStopped] = useState(true);

  return (<>
    <Box
      sx={{
        position: 'relative',
        zIndex: 1200,
        ...(!gift ? {cursor: 'pointer'} : {}),
        ...sx
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!gift) onClick();
      }}
      onMouseEnter={() => { setStopped(false) }} 
      onMouseLeave={() => { setStopped(true) }}
    >
      {!gift && <Lottie
        options={{
          loop: false,
          autoplay: false, 
          animationData: animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        }}
        style={{
          position: 'absolute',
          right: 32,
          bottom: 32,
          zIndex: 1205
        }}
        height={34}
        width={34}
        isClickToPauseDisabled
        isStopped={stopped}
      />}
      {!!gift && <Box sx={{
        "& svg": {
          transform: "rotate(90deg)",
          width: '24px',
          marginBottom: -1
        },
        position: 'absolute',
        right: 32,
        bottom: 32,
        zIndex: 1205
      }}><Arrow /></Box>}


      <Box sx={{
        borderRadius: '10px',
        overflow: 'hidden',
        width: '100%',
        padding: 4,
        height: !gift ? '370px' : '320px',
        // background: `no-repeat url(${ImgLevi})`,
        // backgroundSize: 'cover',
        backgroundColor: 'white'
      }}>
        {!!isNew && <Plus style={{height: '48px'}} />}
        {!isNew && !isApproved && <Graph style={{height: '48px'}} />}
        {/* {!!isApproved && <House style={{height: '48px'}} />} */}
        {!isNew && !!isApproved && <Clover style={{height: '48px'}} />}
        {!!isNew && <Typography variant="h3" sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'initial',
          display: '-webkit-box',
          '-webkit-line-clamp': '3',
          '-webkit-box-orient': 'vertical',
          textTransform: 'none',
          marginTop: 1
        }}>{t("nw.emission.stocks.add_order")}</Typography>}

        {!isNew && !!emissionKey && <>
          {!gift && <>
            <Typography variant="h5" sx={{
              marginTop: 1
            }}>{t("nw.emission.stocks.card.order_time")}</Typography>
            <Typography variant="body1" sx={{
              marginTop: 0,
              paddingLeft: 2
            }}>{emissionKey.time_requested}</Typography>
          </>}
          {!!gift && <>
            <Typography variant="h5" sx={{
              marginTop: 1
            }}>{t("nw.emission.gift.card.redeemer_name")}</Typography>
            <Typography variant="body1" sx={{
              marginTop: 0,
              paddingLeft: 2
            }}>{emissionKey.gift_data?.first_name}</Typography>
          </>}
          <Typography variant="h5" sx={{
            marginTop: 1
          }}>{t("nw.emission.stocks.card.amount")}</Typography>
          <ShareShower variant="body1" amount={emissionKey.proposed_amount || 0} share={shareTypeTag} sx={{
            marginTop: 0,
            paddingLeft: 2
          }} />

          <Typography variant="h5" sx={{
            marginTop: 1
          }}>{t("nw.emission.stocks.card.status")}</Typography>
          <Typography variant="body1" sx={{
            marginTop: 0,
            paddingLeft: 2
          }}>{emissionKey.status}</Typography>

          {!gift && <Typography variant="body2" sx={{
            marginTop: 1,
            paddingLeft: 2
          }}>{emissionKey.status_updated}</Typography>}
          {!!gift && <Typography variant="body2" sx={{
            marginTop: 1,
            paddingLeft: 2
          }}>{emissionKey.asn_key}</Typography>}
        </>}

        {!gift && <MutedGreenButton
          id="goto"
          label={!!isNew ? t("nw.emission.stocks.card.new_order") : t("nw.emission.stocks.card.view_order")}
          onClick={() => {
            onClick();
          }}
          sx={{
            position: 'absolute',
            bottom: 32,
            left: 32
          }}
        />}
      </Box>
    </Box>
  </>);
}